import { api } from './api';
import type { Stats } from '../types';

export const statsApi = {
  get: () => api.get<Stats>('/stats'),
};
